import clsx from 'clsx';
import {
    useController,
    Control,
    Path,
    FieldValues,
} from 'react-hook-form';
import {HTMLInputTypeAttribute} from 'react';
import * as inputStyles from './input.module.css';

interface IInputReadOnlyProps<T> {
    name: Path<T>,
    control: Control<FieldValues>,
    type?: HTMLInputTypeAttribute,
    defaultValue?: Path<FieldValues>,
    title?: string,
}

const InputReadOnly = <T extends Record<string, any> >({
    control,
    defaultValue,
    name,
    type = 'text',
    title,
}: IInputReadOnlyProps<T>) => {
    const {
        field: {
            value,
            ref,
        },
    } = useController<FieldValues>({
        name,
        control,
        defaultValue,
    });

    return (
        <span className={inputStyles.root}>
            <span
                className={clsx(
                    inputStyles.inputWrapper,
                    !title && inputStyles.noTitle,
                )}
            >
                <span className={inputStyles.title}>
                    {title}
                </span>
                <input
                    ref={ref}
                    type={type}
                    name={name}
                    defaultValue={defaultValue}
                    className={inputStyles.inputReadOnly}
                    value={value || ''}
                    disabled={true}
                />
            </span>
        </span>
    );
};

export default InputReadOnly;
